export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        padding: "10px 0",
        textAlign: "center",
        fontSize: "0.85rem",
        color: "#bbb",
        borderTop: "1px solid #333",
        marginTop: "20px",
      }}
    >
      <div>© {year} Ariel Reches — FantasyPremChat</div>

      <div style={{ marginTop: "5px", opacity: 0.85 }}>
        <a
          href="https://github.com/arielreches/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#888", margin: "0 8px" }}
        >
          GitHub
        </a>
        |
        <a
          href="https://www.linkedin.com/in/ariel-reches-83856188/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#888", margin: "0 8px" }}
        >
          LinkedIn
        </a>
        |
        <span style={{ marginLeft: "8px" }}>v1.0.0</span>
      </div>
    </footer>
  );
}
